import { FC } from 'react';

import CommunicationsSidenav from 'modules/communications/components/CommunicationsSidenav';
import { sections } from 'modules/communications/constants/sections';

import { useCommunicationsPage } from '../context/CommunicationsPageContext';
import CommunicationsList from './CommunicationsList';
import CommunicationsSetting from './CommunicationsSetting';

const CommunicationsPageBody: FC = () => {
  const { data, actions } = useCommunicationsPage();

  const isInboxView = data.section === sections.INBOX;

  return (
    <div className="nk-content-wrap">
      <div className="nk-ibx">
        <CommunicationsSidenav
          section={data.section}
          totalUnreadCommunications={data.totalUnreadCommunications}
          handleToggleInboxSection={actions.handleToggleInboxSection}
          handleToggleSettingsSection={actions.handleToggleSettingsSection}
        />

        <div className="nk-ibx-body bg-white d-flex flex-column">
          {isInboxView ? (
            <div className="nk-ibx-list inbox-list-wrapper">
              <CommunicationsList />
            </div>
          ) : (
            <CommunicationsSetting />
          )}
        </div>
      </div>
    </div>
  );
};

export default CommunicationsPageBody;
